import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import JobSearch from "./JobSearchComponent";
import DiscoverJobListComponent from "./jobs-section/discover-jobs/DiscoverJobListComponent";

const LastMinuteContent = () => <p>Last Minute Jobs Content</p>;
const SavedJobsContent = () => <p>Saved Jobs Content will appear here.</p>;

const JobsComponent = () => {
  const navigate = useNavigate();
  const { jobType: urlTab } = useParams();
const [activeTab, setActiveTab] = useState(urlTab || "open");

  const tabNames = {
    open: "Open Jobs",
    "last-minute": "Last Minute",
    "saved-jobs": "Saved Jobs",
  };

  const tabComponents = {
    open: <DiscoverJobListComponent />,
    "last-minute": <LastMinuteContent />,
    "saved-jobs": <SavedJobsContent />,
  };

  useEffect(() => {
  setActiveTab(urlTab || "open");
}, [urlTab]);

  const handleTabClick = (key) => {
    navigate(`/account/ps-dashboard/job-listings/${key}`);
    setActiveTab(key);
  };

  return (
    <div className="post-jobs-container">
      <div className="post-jobs-tabs">
        <div className="tabs-group">
          <div className="tabs">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="post-job-tab-content">{tabComponents[activeTab]}</div>
    </div>
  );
};

export default JobsComponent;
